import React,{useState} from "react";
import { Box, FormControl, InputLabel, Select, MenuItem, Button,TextField } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const CourseRecordSearchForm=({date,setDate,handleRecord})=>{
     return(
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box display="flex" alignItems="center" mb={3}>
                <DatePicker
                    label="Course Record Date"
                    value={date?dayjs(date):null}
                    onChange={(newValue)=>{
                        const formattedDate=dayjs(newValue).format('YYYY-MM-DD');
                        setDate(formattedDate);
                    
                    }}
                    renderInput={(params)=> <TextField {...params} sx={{mr:2}}/>}
                >

                </DatePicker>
                <Button variant="contained" color="primary" onClick={handleRecord} sx={{mr:2}}>
                    Record Input
                </Button>
            </Box>
        </LocalizationProvider>
     );
};

export default CourseRecordSearchForm;